import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const LockFilled: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 12, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={(+size * 15) / 12}
      viewBox="0 0 12 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.5 5.625H10V3.75C10 1.68182 8.20605 0 6 0C3.79395 0 2 1.68182 2 3.75V5.625H1.5C0.67334 5.625 0 6.25557 0 7.03125V13.5938C0 14.3694 0.67334 15 1.5 15H10.5C11.3267 15 12 14.3694 12 13.5938V7.03125C12 6.25557 11.3267 5.625 10.5 5.625ZM3.33337 3.75C3.33337 2.37122 4.5293 1.25004 6 1.25004C7.4707 1.25004 8.66663 2.37122 8.66663 3.75V5.625H3.33337V3.75Z"
        fill="currentColor"
      />
    </svg>
  )
})

LockFilled.displayName = 'LockFilled'
